<mcg-loader [message]="translate('Cargando_datos')" [showLoader]="isLoading()"></mcg-loader>
<mcg-window #form [width]="950" [height]="400" [canResize]="false" [title]="titleWindowSignal()"
  [actions]="actions" (actionButtonClicked)="actionButtonClicked($event)" (windowClosed)="onClose()">
  <app-header #header [exportar]="true" [buscador]="true" [filtro]="true" [resetFiltro]="true"
    [seeNumVisible]="true" [seeZonas]="true" [sourceZonas]="zonas" (eventExportar)="onExportar()"
    (eventBuscador)="onBuscar()" (eventChangeNumVisible)="onChangeNumVisible($event)"
    (eventChangeZona)="onChangeZonaFiltro($event)" (eventFilter)="eventFilter()"
    (eventResetFilter)="eventResetFilter()">
  </app-header>
  <div class="divGrid">
    <jqxGrid #myGrid [theme]="theme" [width]="'100%'" [height]="'99%'" [source]="dataAdapter" [appCellClick]
      [columnsresize]="true" [localization]="langGrid" [filterable]="true" [columns]="columns"
      [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true"
      [showstatusbar]="false" [showaggregates]="false" [rowsheight]="25"
      [columnsheight]="20" [editable]="false" [filter]="filter" [updatefilterconditions]="updatefilterconditions"
      [enablebrowserselection]="true" (onRowclick)="onRowclick($event)" (onRowdoubleclick)="onRowdoubleclick($event)"
      (onFilter)="onFilter()" (onBindingcomplete)="onBindingComplete()">
    </jqxGrid>
  </div>
</mcg-window>

<app-editar-cuadricula
  *ngIf="editorCuadricula"
  [cuadricula]="cuadricula"
  [lado_minimo_cuadricula]="LADO_MINIMO_CUADRICULA"
  [zonas]="zonas"
  (createMarco)="onCreateMarco()"
  (cuadriculaOutput)="onSaveCuadricula($event)"
  (closeForm)="onCloseForm()"
>
</app-editar-cuadricula>
